import { Sparkles, ShoppingBag, Users, Home, Droplets } from "lucide-react";

export const IDEAS = [
  {
    slug: "cleaning-service-florida",
    icon: Sparkles,
    badge: "Fixfertige Business-Idee",
    title: "Cleaning Service in Florida gründen",
    short: "Bereits erprobt und fixfertig: Reinigungsservice für Ferienwohnungen (Airbnb) und private Haushalte – inklusive durchdachtem Businessplan.",
    description:
      "Cleaning Service in Florida gründen: erprobtes Konzept für Airbnb- und Privatreinigung, fixfertig mit Businessplan und Gründungsbegleitung – auf Deutsch.",
    keywords:
      "Cleaning Service Florida gründen, Reinigungsfirma Florida gründen, Airbnb Reinigung Service, Putzservice USA gründen, Reinigungsservice Sarasota, Business Idee Florida Reinigung",
    lead: "Ein Cleaning Service in Florida ist ein erprobter Einstieg in den US-Markt: Ferienwohnungen und private Haushalte brauchen laufend zuverlässige Reinigung – und unser Konzept dafür liegt fixfertig vor.",
    blocks: [
      {
        heading: "Warum ein Cleaning Service in Florida?",
        paragraphs: [
          "Florida lebt vom Tourismus und von Zweitwohnsitzen: Ferienwohnungen müssen bei jedem Gästewechsel gereinigt werden, und viele Eigentümer sind selbst nicht vor Ort. Reinigung ist ein wiederkehrendes, planbares Geschäft – kein einmaliger Verkauf, sondern laufende Aufträge.",
          "Dazu kommt: Der Einstieg ist überschaubar komplex. Mit dem richtigen Aufbau, gutem Personal und verlässlichen Abläufen entsteht ein Geschäft, das wächst, sobald die ersten Kunden Stammkunden werden.",
        ],
      },
      {
        heading: "Ihre Zielgruppen: Airbnb-Gastgeber und private Haushalte",
        list: [
          "Gastgeber von Airbnb- und Ferienwohnungen – Reinigung bei jedem Gästewechsel",
          "Private Haushalte – regelmässige Reinigung im Wochen- oder Monatsrhythmus",
          "Eigentümer von Zweitwohnsitzen, die das Objekt schlüsselfertig übergeben wollen",
        ],
      },
      {
        heading: "Was unser fixfertiges Konzept enthält",
        list: [
          "Erprobtes Geschäftskonzept, auf den Markt in Florida zugeschnitten",
          "Fertiger Businessplan – auch für Visumsanträge verwendbar",
          "Gründungsbegleitung, bis Ihr Cleaning Service steht und läuft",
        ],
      },
      {
        heading: "Passend zu Ihrem Visum",
        paragraphs: [
          "Ein Cleaning Service ist ein reales, aktiv geführtes Unternehmen – genau die Art von Geschäft, die Visumswege wie das E-2 Visum verlangen. Wir stimmen das Konzept mit Ihrer Visumsstrategie ab, damit Gründung und Antrag zusammenpassen.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Der Markt lebt von Verlässlichkeit: Wiederkehrende Aufträge von Airbnb-Gastgebern und Stammkunden sind das Rückgrat des Geschäfts. Wir zeigen Ihnen, wie Aufbau, Personal und Qualitätssicherung gelingen – statt Sie mit der Idee allein zu lassen.",
    },
    faq: [
      {
        q: "Brauche ich Erfahrung in der Reinigungsbranche?",
        a: "Nicht zwingend. Unser Konzept führt Sie durch Aufbau, Personal und Abläufe – wichtiger als Branchenerfahrung sind Organisation und Zuverlässigkeit.",
      },
      {
        q: "Ist der Cleaning Service fürs E-2 Visum geeignet?",
        a: "Ja. Es ist ein reales, aktiv geführtes Dienstleistungsunternehmen mit wiederkehrenden Umsätzen – genau das, was das E-2 Visum verlangt. Wir stimmen Konzept und Visumsantrag aufeinander ab.",
      },
      {
        q: "Kann ich das Konzept an meine Region in Florida anpassen?",
        a: "Ja. Ob Sarasota, Naples, Cape Coral oder eine andere Region – wir passen das Konzept an Ihren Standort und Ihre Stärken an.",
      },
    ],
    closing:
      "Wir richten das Konzept auf Sie und Ihren Standort aus, stimmen es mit Ihrer Visumsstrategie ab und begleiten die Gründung – persönlich und auf Deutsch.",
  },
  {
    slug: "e-commerce-florida",
    icon: ShoppingBag,
    badge: "Fixfertige Business-Idee",
    title: "E-Commerce in Florida starten",
    short: "Erprobtes E-Commerce-Konzept für den US-Markt – fixfertig vorbereitet und auf Floridas Markt zugeschnitten.",
    description:
      "E-Commerce in Florida starten: erprobtes Konzept für den US-Markt, fixfertig mit Businessplan und Gründungsbegleitung – passend zu Ihrer Visumsstrategie.",
    keywords:
      "E-Commerce Florida starten, Online Shop USA gründen, E-Commerce Business USA, Onlinehandel Florida, Amazon FBA USA deutsch, E-Commerce Auswanderer USA",
    lead: "E-Commerce ist der flexible Einstieg in den US-Markt: ortsunabhängig, skalierbar und von Florida aus bestens aufgestellt. Unser Konzept dafür ist erprobt und fixfertig.",
    blocks: [
      {
        heading: "Warum E-Commerce von Florida aus?",
        paragraphs: [
          "Der US-Markt ist der grösste Online-Markt der Welt – und Florida ist eine starke Basis dafür: gute Logistik, wachsende Bevölkerung und kein persönlicher Einkommensteuersatz auf Staatsebene. Dazu arbeitet ein E-Commerce-Geschäft ortsunabhängig: Sie können es aufbauen, während Sie noch in Deutschland oder der Schweiz sind, und es wächst mit Ihrem Umzug mit.",
        ],
      },
      {
        heading: "Was unser fixfertiges Konzept enthält",
        list: [
          "Erprobtes E-Commerce-Konzept für den US-Markt",
          "Fertiger Businessplan – auch für Visumsanträge verwendbar",
          "Gründungsbegleitung: US-Unternehmen, Struktur und Start Ihres Geschäfts",
        ],
      },
      {
        heading: "E-Commerce und Visum – das sollten Sie wissen",
        paragraphs: [
          "Auch ein Online-Geschäft kann ein Visum wie das E-2 tragen – aber nur, wenn es ein reales, aktiv geführtes Unternehmen mit Substanz ist: echte operative Tätigkeit, nachvollziehbare Abläufe, gegebenenfalls Lager oder Personal in den USA. Genau darauf legen wir das Konzept aus, damit es nicht nur auf dem Papier existiert.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "E-Commerce ist kein passives Einkommen: Sortiment, Logistik und Kundenservice wollen aktiv geführt werden. Unser Konzept zeigt Ihnen die realistischen Abläufe – und wir bleiben auch nach dem Start an Ihrer Seite.",
    },
    faq: [
      {
        q: "Ist E-Commerce fürs E-2 Visum geeignet?",
        a: "Ja, sofern es ein reales, aktiv geführtes Unternehmen mit Substanz ist – nicht nur ein Shop im Netz. Wir richten Konzept und Unternehmensstruktur genau darauf aus.",
      },
      {
        q: "Brauche ich Lagerfläche in Florida?",
        a: "Das hängt vom Modell ab – ob eigenes Lager, Fulfillment-Partner oder Direktversand. Was zu Ihrem Konzept passt, besprechen wir im Erstgespräch.",
      },
      {
        q: "Kann ich das Sortiment selbst wählen?",
        a: "Ja. Das Konzept ist erprobt, aber flexibel: Sortiment und Ausrichtung passen wir an Ihre Stärken und Ziele an.",
      },
    ],
    closing:
      "Wir richten das E-Commerce-Konzept auf Ihre Ziele aus, stimmen es mit Ihrer Visumsstrategie ab und begleiten den Start – persönlich und auf Deutsch.",
  },
  {
    slug: "hauspersonal-vermittlung-florida",
    icon: Users,
    badge: "Fixfertige Business-Idee",
    title: "Hauspersonal-Vermittlung & Recruiting in Florida",
    short: "Vermittlung von Hauspersonal und Recruiting: ein erprobtes Vermittlungsmodell für Floridas Haushalte und Unternehmen.",
    description:
      "Hauspersonal vermitteln in Florida: erprobtes Konzept für Vermittlung & Recruiting, fixfertig mit Businessplan und Gründungsbegleitung – auf Deutsch.",
    keywords:
      "Hauspersonal Vermittlung Florida, Personalvermittlung USA gründen, Recruiting Florida, Haushaltshilfe vermitteln USA, Staffing Agency Florida gründen, Hauspersonal Service Sarasota",
    lead: "Floridas Haushalte und Ferienobjekte brauchen verlässliches Personal – und genau das zu finden, ist schwer. Unsere Hauspersonal-Vermittlung ist ein erprobtes Modell, das fixfertig vorliegt.",
    blocks: [
      {
        heading: "Warum Hauspersonal-Vermittlung in Florida?",
        paragraphs: [
          "Florida wächst – und mit den Haushalten, Villen und Ferienobjekten wächst der Bedarf an verlässlichem Personal: Housekeeping, Hausmeister, Betreuung. Gutes Personal zu finden ist für Eigentümer eine echte Hürde. Wer diese Lücke professionell schliesst, baut ein Geschäft mit wiederkehrenden Kundenbeziehungen auf.",
        ],
      },
      {
        heading: "Ihre Zielgruppen",
        list: [
          "Eigentümer von Zweitwohnsitzen und Villen, die nicht dauerhaft vor Ort sind",
          "Ferienhaus-Verwaltungen und Gastgeber mit Personalbedarf",
          "Private Haushalte, die langfristig Unterstützung suchen",
        ],
      },
      {
        heading: "Vermittlung und Recruiting als zwei Standbeine",
        paragraphs: [
          "Das Konzept verbindet beides: die Vermittlung von Hauspersonal an Eigentümer und Haushalte sowie das aktive Recruiting geeigneter Kräfte. So entsteht ein Modell, das auf beiden Seiten Wert schafft – bei den Kunden und bei den vermittelten Fachkräften.",
        ],
      },
      {
        heading: "Was unser fixfertiges Konzept enthält",
        list: [
          "Erprobtes Vermittlungsmodell für den Markt in Florida",
          "Fertiger Businessplan – auch für Visumsanträge verwendbar",
          "Gründungsbegleitung, bis Ihr Vermittlungsgeschäft läuft",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Vertrauen ist in dieser Branche alles: Eigentümer lassen Menschen in ihre Häuser. Sorgfältige Auswahl und klare Prozesse sind der Kern des Konzepts – genau das unterscheidet eine professionelle Vermittlung von einer informellen Empfehlung.",
    },
    faq: [
      {
        q: "Brauche ich eine Lizenz für die Personalvermittlung in Florida?",
        a: "Je nach genauer Tätigkeit können Registrierungen nötig sein. Was in Ihrem Fall gilt, klären wir im Rahmen der Gründungsbegleitung – bevor Sie starten.",
      },
      {
        q: "Ist das Vermittlungsmodell fürs E-2 Visum geeignet?",
        a: "Ja. Es ist ein reales, aktiv geführtes Dienstleistungsunternehmen – genau die Art von Geschäft, die das E-2 Visum verlangt.",
      },
      {
        q: "Wie finde ich geeignetes Personal?",
        a: "Das Konzept enthält einen erprobten Recruiting-Ansatz: von der Suche über die Auswahl bis zur Platzierung. Sie starten nicht bei null.",
      },
    ],
    closing:
      "Wir richten das Vermittlungsmodell auf Ihre Zielregion aus, stimmen es mit Ihrer Visumsstrategie ab und begleiten die Gründung – persönlich und auf Deutsch.",
  },
  {
    slug: "homewatch-service-florida",
    icon: Home,
    badge: "Fixfertige Business-Idee",
    title: "Homewatch-Service für Zweitwohnsitze in Florida",
    short: "Regelmässige Kontrolle und Betreuung von Zweitwohnsitzen, während die Eigentümer nicht vor Ort sind.",
    description:
      "Homewatch-Service in Florida gründen: Zweitwohnsitze kontrollieren und betreuen – erprobtes Konzept, fixfertig mit Businessplan und Gründungsbegleitung.",
    keywords:
      "Homewatch Service Florida, Hausüberwachung Florida, Zweitwohnsitz Betreuung Florida, Home Watch Business USA gründen, Ferienhaus betreuen Florida, Homewatch Sarasota",
    lead: "Tausende Ferienhäuser und Zweitwohnsitze in Florida stehen monatelang leer – und ihre Eigentümer sind weit weg. Ein Homewatch-Service übernimmt Kontrolle und Betreuung. Unser Konzept dafür ist erprobt und fixfertig.",
    blocks: [
      {
        heading: "Was ist ein Homewatch-Service?",
        paragraphs: [
          "Homewatch bedeutet: Sie schauen regelmässig nach dem Objekt Ihrer Kunden, wenn diese nicht da sind. Sichtkontrollen innen und aussen, Post, Technik-Checks, Koordination von Handwerkern – und nach jedem Besuch ein Bericht an den Eigentümer. So wissen Ihre Kunden jederzeit: Zuhause ist alles in Ordnung.",
        ],
      },
      {
        heading: "Warum Florida der richtige Markt ist",
        paragraphs: [
          "Florida ist der Klassiker für Zweitwohnsitze – viele Eigentümer aus Deutschland, der Schweiz und anderen US-Staaten sind nur wenige Wochen im Jahr vor Ort. Dazu kommt die Hurrikansaison: Nach Stürmen wollen Eigentümer schnell wissen, ob ihr Objekt unbeschadet ist. Ein verlässlicher Homewatch-Service beantwortet genau das.",
        ],
      },
      {
        heading: "Ihre Zielgruppen",
        list: [
          "Eigentümer von Zweitwohnsitzen und Ferienhäusern",
          "Internationale Eigentümer, die ihr Florida-Objekt aus der Ferne betreuen lassen wollen",
          "Ferienhaus-Verwaltungen, die Kontrollgänge auslagern möchten",
        ],
      },
      {
        heading: "Was unser fixfertiges Konzept enthält",
        list: [
          "Erprobtes Homewatch-Konzept mit klaren Abläufen und Checklisten",
          "Fertiger Businessplan – auch für Visumsanträge verwendbar",
          "Gründungsbegleitung, bis Ihr Homewatch-Service läuft",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Homewatch ist ein Vertrauensgeschäft: Kunden übergeben Ihnen ihre Hausschlüssel. Nachvollziehbare Abläufe, dokumentierte Besuche und klare Kommunikation sind das Herzstück – unser Konzept baut genau darauf auf.",
    },
    faq: [
      {
        q: "Was gehört zu einem Homewatch-Besuch?",
        a: "Sichtkontrollen innen und aussen, Technik- und Wetter-Checks, Post und Kleinigkeiten – plus Koordination von Handwerkern bei Bedarf. Nach jedem Besuch erhalten Ihre Kunden einen Bericht, typischerweise mit Fotos.",
      },
      {
        q: "Brauche ich dafür eine Lizenz in Florida?",
        a: "Welche Registrierungen in Ihrem konkreten Fall nötig sind, klären wir im Rahmen der Gründungsbegleitung – bevor Sie starten.",
      },
      {
        q: "Ist Homewatch fürs E-2 Visum geeignet?",
        a: "Ja. Es ist ein reales, aktiv geführtes Servicegeschäft mit wiederkehrenden Kunden – genau das, was das E-2 Visum verlangt.",
      },
    ],
    closing:
      "Wir richten das Homewatch-Konzept auf Ihre Region aus, stimmen es mit Ihrer Visumsstrategie ab und begleiten die Gründung – persönlich und auf Deutsch.",
  },
  {
    slug: "poolpflege-service-florida",
    icon: Droplets,
    badge: "Fixfertige Business-Idee",
    title: "Poolpflege-Service in Florida gründen",
    short: "Poolpflege und regelmässiger Poolservice für private Haushalte und Ferienobjekte in ganz Florida.",
    description:
      "Poolpflege-Service in Florida gründen: erprobtes Konzept für Poolservice an Privathaushalten und Ferienobjekten – fixfertig mit Businessplan und Gründungsbegleitung.",
    keywords:
      "Poolpflege Florida gründen, Pool Service Business USA, Poolreinigung Florida, Poolpflege Service Sarasota, Pool Business Florida, Poolservice gründen USA",
    lead: "Pools gehören in Florida fast zur Grundausstattung – und sie wollen gepflegt werden, das ganze Jahr. Ein Poolpflege-Service ist ein wiederkehrendes Geschäft mit planbaren Umsätzen. Unser Konzept liegt fixfertig vor.",
    blocks: [
      {
        heading: "Warum Poolpflege in Florida?",
        paragraphs: [
          "In kaum einem Bundesstaat gibt es so viele Pools wie in Florida – im Garten privater Häuser, bei Ferienobjekten und in Wohnanlagen. Ganzjähriges warmes Wetter bedeutet: Pflegebedarf das ganze Jahr über, nicht nur im Sommer. Wer einmal einen Pool übernimmt, bleibt in der Regel langfristig Kunde.",
        ],
      },
      {
        heading: "Ihre Leistungen im Überblick",
        list: [
          "Regelmässige Poolpflege: Reinigung und Kontrolle der Wasserwerte",
          "Betreuung von Ferienobjekten zwischen den Belegungen",
          "Koordination kleinerer Reparaturen und Technik-Checks",
          "Feste Serviceintervalle mit dokumentierten Besuchen",
        ],
      },
      {
        heading: "Ihre Zielgruppen",
        list: [
          "Private Haushalte mit eigenem Pool",
          "Ferienvermietungen und Airbnb-Gastgeber mit Pool-Objekten",
          "Eigentümer von Zweitwohnsitzen, die nicht vor Ort sind",
        ],
      },
      {
        heading: "Was unser fixfertiges Konzept enthält",
        list: [
          "Erprobtes Poolpflege-Konzept für den Markt in Florida",
          "Fertiger Businessplan – auch für Visumsanträge verwendbar",
          "Gründungsbegleitung, bis Ihr Poolpflege-Service läuft",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Poolpflege ist ein Routinengeschäft: Feste Touren, feste Intervalle, verlässliche Qualität. Wachstum entsteht über Stammkunden und Empfehlungen in der Nachbarschaft – unser Konzept zeigt Ihnen, wie der Markteinstieg gelingt.",
    },
    faq: [
      {
        q: "Brauche ich eine Lizenz für Poolpflege in Florida?",
        a: "Für manche Tätigkeiten – etwa bestimmte Reparaturen – gibt es Anforderungen. Was für Ihr konkretes Angebot gilt, klären wir im Rahmen der Gründungsbegleitung.",
      },
      {
        q: "Ist der Poolpflege-Service fürs E-2 Visum geeignet?",
        a: "Ja. Es ist ein reales, aktiv geführtes Servicegeschäft mit wiederkehrenden Umsätzen – genau die Art von Unternehmen, die das E-2 Visum verlangt.",
      },
      {
        q: "Wie komme ich an die ersten Kunden?",
        a: "Das Konzept enthält einen erprobten Ansatz für den Markteinstieg – von der lokalen Akquise bis zu Kooperationen mit Ferienvermietungen.",
      },
    ],
    closing:
      "Wir richten das Poolpflege-Konzept auf Ihre Region aus, stimmen es mit Ihrer Visumsstrategie ab und begleiten die Gründung – persönlich und auf Deutsch.",
  },
];

export function getIdea(slug) {
  return IDEAS.find((i) => i.slug === slug);
}
